// extracted by mini-css-extract-plugin
export default {"ExternalLink":"index_ExternalLink__3c0pq","ExternalLinkInText":"index_ExternalLinkInText__f2vy7","ExternalLinkButton":"index_ExternalLinkButton__2tE4P"};